
import Logo from '@/assets/images/home/logo.png'
import settings from '@/config/default/setting.config'
import { defineComponent } from 'vue'
export default defineComponent({
  props: {
    collapse: {
      type: Boolean,
      default: true
    }
  },
  setup() {
    const title = settings.title
    return {
      title,
      Logo
    }
  }
})
